<template>
    <div class="p-4 bg-white rounded-10 overflow-hidden text-a-brown-502314">
        <div class="flex">
            <img class="ml-0 mr-2 my-auto" src="@/assets/icon/ic-delivery-brown.svg" />
            <div class="ml-0 mr-auto my-auto font-bold">{{lbl.deliverymethod.delivery_to}}</div>
            <div @click="clickSelect()"
                class="ml-auto mr-0 my-auto text-14 text-a-red-d62300 cursor-pointer">
                {{lbl.deliverymethod.select_add}}
            </div>
        </div>
        <div class="bg-a-egg-f5ebdc p-4 rounded-10 overflow-hidden mt-2" v-if="address">
            <div class="flex">
                <div class="ml-0 mr-auto font-bold">{{address.addressName}}</div>
                <img class="ml-auto mr-0 cursor-pointer" src="@/assets/icon/ic-edit-brown.svg" @click="clickEdit()" />
            </div>
            <div class="text-14 text-a-brown-9f8273">{{getAddress()}}</div>
            <div class="text-14">{{address.building}}</div>
        </div>
        <div class="bg-a-egg-f5ebdc p-4 rounded-10 overflow-hidden mt-2" v-else>
            <div class="text-center text-a-brown-9f8273 text-14">Please choose your locations.</div>
        </div>
        <div class="text-center text-12 mt-2">{{lbl.deliverymethod.if_you_change}}</div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "Delivery",
    inject: ['DeliveryStore'],
    mixins: [LocaleMixin],
    props: {
        address: { type: Object}
    },
    methods: {
        getAddress: function () {
            var address = "";
            if (this.address.number) {
                address += this.address.number + " ";
            }
            if (this.address.soi) {
                address += this.address.soi + " ";
            }
            if (this.address.subDistrictName) {
                address += this.address.subDistrictName + " ";
            }
            if (this.address.districtName) {
                address += this.address.districtName + " ";
            }

            if (this.address.zipcode) {
                address += this.address.zipcode;
            }
            return address;
        },
        clickSelect: function() {
            this.$router.push("/selectaddress");
        },
        clickEdit: function() {
            this.DeliveryStore.methods.initAddress();
            this.DeliveryStore.state.address = {...this.address};
            this.$router.push('/editaddress?from=deliverymethod');
        }
    } 
    
}
</script>

<style lang="scss" scoped>

</style>